import styled from 'styled-components';
import axios from 'axios';

const getVar = () => {

    const root = isLocalHost() ? 'http://wpengine.parsons.local' : '';
    const restPath = '/wp-json/psn-vw/v1/';
    let tileUrl = 'https://api.mapbox.com/styles/v1/michaelsoriano/ckbb0jvdx06yp1hoh3vepkqnu/tiles/{z}/{x}/{y}';
    tileUrl += '?access_token=pk.eyJ1IjoibWljaGFlbHNvcmlhbm8iLCJhIjoiY2tiYjA3aWFzMG95ODJ0bzRpb25sZjFtcCJ9.KQ7gSeg4I9lQlrOTys0AXA'; 
 
    return {   
        apiUrl      : root + restPath,        
        baseUrl     : root, 
        tileUrl     : tileUrl, 
        s3Url       : 'https://parsonsecmpublic.s3.amazonaws.com/virtual-world/',        
        markerIcon  : 'https://parsonsecmpublic.s3.amazonaws.com/virtual-world/marker.svg', 
        markerShadow: 'https://parsonsecmpublic.s3.amazonaws.com/virtual-world/marker-shadow.png',
        logoUrl     : 'https://parsonsecmpublic.s3.amazonaws.com/virtual-world/parsons-logo-white.png',
        catStr      : '{"ci":"Critical Infrastructure","in":"Intelligence","de":"Defense"}',
        lg          : '1199px', 
        med         : '767px', 
        sm          : '576px', 
        version     : '2.0.1'
    }

}

const isLocalHost = () => {
   return window.location.host.indexOf('localhost') !== -1;
}

const Title = styled.div`
    font-size:22px;        
    margin-bottom:15px;
`;

const SubTitle = styled.div`
    font-size:18px;        
    margin-bottom:10px;
`;

const SmallTitle = styled.h4`
    font-size:15px;
    font-weight:600;        
    margin-bottom:10px;
`;

const ProductTitle = styled.h5`
    font-size:13px;
    font-weight:500;   
    background:#fff;
    padding: 10px 12px 0px;  
`;

const Text = styled.div`
    font-size:13px;        
    margin-bottom:10px;
    color: #828282;
`;

const Sidebar = styled.div`
    background: #f2f2f2; 
    height : 100%; 
    position : fixed;    
    width : ${props => props.width};
    
    ${({ side }) => side === 'right' ? `
        right : 0px;
    ` : `
        left : 0px;
    `}
    
    top : 0px;
    box-shadow : 0 15px 35px rgb(50 50 93 / 20%), 0 5px 15px rgb(0 0 0 / 17%);
    z-index: 1051;
    padding: 15px 15px;
    overflow-y: auto;
    overflow-x: hidden;
    @media (max-width: 1199px) {
        width: 60%;
    }   
    @media (max-width: 767px) {
        width: 75%;
    }  
`;

const buildMarketFilters = ()=>{
    let categoryStr = getVar().catStr;
    let categoryObj = JSON.parse(categoryStr);     
    let markets = [];
    for(let key in categoryObj){
        let market = {};
        market.name = categoryObj[key];
        market.key = key;
        market.imgUrl = getVar().s3Url + 'category-'+key+'.png';
        markets.push(market);
    }
    return markets;
} 

const buildCatFilters = (callback) => {
    axios.get(getVar().apiUrl+'get-plots/').then(response => {
        var plots = response.data; 
        var catsAll = [];
        for(let x=0; x < plots.length; x++){
            if(plots[x].categories){
                let y = plots[x].categories.split(',');                    
                for(let u=0; u < y.length; u++){
                    catsAll.push(y[u]);
                }
            }
        }
        let uniqueCats = catsAll.filter(function(item, pos, self) {
            return self.indexOf(item) === pos;
        })
        let filters = [];
        for(let q=0; q < uniqueCats.length; q++){
            let singleCat = {};
            let temp = uniqueCats[q].split('::');
            singleCat.label = temp[0] ? temp[0] : '';
            singleCat.id = temp[1] ? temp[1] : '';
            singleCat.count = temp[2] ? temp[2] : '';
            singleCat.group = temp[3] ? temp[3] : '';
            filters.push(singleCat);
        }
        callback(filters);             
    })
} 


export {
    getVar, 
    isLocalHost, 
    Title, 
    SubTitle, 
    SmallTitle,
    ProductTitle,
    Text, 
    Sidebar, 
    buildCatFilters,
    buildMarketFilters
}